var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlphabetical = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 48,
    viewBox: "0 0 40 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Sort-Alphabet-Ascending-path",
    d: "M10.8299 47.4252C10.5255 47.7892 10.0755 48 9.60032 48C9.12512 48 8.67512 47.7892 8.37072 47.4248L0.370724 37.8248C-0.194876 37.1452 -0.102876 36.1356 0.575524 35.57C1.25672 35.0044 2.26312 35.0964 2.83032 35.7748L8.00032 41.98V1.6C8.00032 0.7156 8.71592 0 9.60032 0C10.4847 0 11.2003 0.7156 11.2003 1.6V41.98L16.3707 35.7752C16.9363 35.0972 17.9443 35.0048 18.6255 35.5704C19.3035 36.136 19.3955 37.1452 18.8299 37.8252L10.8299 47.4252Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Sort-Alphabet-Ascending-path_2",
    d: "M38.4003 46.4008C38.4003 45.5164 37.6847 44.8008 36.8003 44.8008H30.0267L38.1719 31.2244C38.4687 30.7308 38.4767 30.1152 38.1923 29.612C37.9083 29.11 37.3767 28.8008 36.8003 28.8008H27.2003C26.3159 28.8008 25.6003 29.5164 25.6003 30.4008C25.6003 31.2852 26.3159 32.0008 27.2003 32.0008H33.9739L25.8283 45.5772C25.5315 46.0708 25.5235 46.6864 25.8079 47.1896C26.0923 47.6916 26.6239 48.0008 27.2003 48.0008H36.8003C37.6847 48.0008 38.4003 47.2852 38.4003 46.4008Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4003 17.6V6.4C38.4003 2.8704 35.5299 0 32.0003 0C28.4707 0 25.6003 2.8704 25.6003 6.4V17.6C25.6003 18.4844 26.3159 19.2 27.2003 19.2C28.0847 19.2 28.8003 18.4844 28.8003 17.6V12.8H35.2003V17.6C35.2003 18.4844 35.9159 19.2 36.8003 19.2C37.6847 19.2 38.4003 18.4844 38.4003 17.6ZM35.2003 6.4V9.6H28.8003V6.4C28.8003 4.636 30.2363 3.2 32.0003 3.2C33.7643 3.2 35.2003 4.636 35.2003 6.4Z",
    fill: "#4A4A4A"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlphabetical);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alphabetical.353eff9147db6abd417f575529925aa6.svg";